import { LoginForm } from './LoginForm'

export { LoginSSO } from './LoginSSO'

export const Login = LoginForm
